export default {
  GET_KEYPAD_NEXT_BUTTON_TABLE_BUBBLE: (state) => {
    return state.keypadNextButtonTableBubble;
  },
  GET_CURRENT_CELL_INDEX: (state) => {
    return state.nextTableBubbleCellIndex;
  },
};
